import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { TextField } from "@mui/material";
import PaymentMethodsDataTable from "../components/data-tables/PaymentMethodsDataTable";
import { API } from "../assets/staticData";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function PaymentMethod({ user }) {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const formData = new FormData();
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();

  const [data, setData] = useState({
    methodName: "",
    description: "",
    link: "",
    public: true,
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/payment-methods?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setItems(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };
  const handleImage2Change = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage2(file);
    }
  };

  const uploadImage = async (file) => {
    const imageFormData = new FormData();
    imageFormData.append("files", file);

    const response = await fetch(`${API}/upload`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      method: "POST",
      body: imageFormData,
    });

    const result = await response.json();
    return result[0]?.url;
  };

  const uploadData = async () => {
    if (data.methodName !== "" && data.link !== "" && image !== null && image2 !== null) {
      const imageUrl = await uploadImage(image);
      const image2Url = await uploadImage(image2);

      fetch(`${API}/payment-methods`, {
        headers,
        method: "POST",
        body: JSON.stringify({
          data: {
            ...data,
            public: true,
            image: imageUrl,
            image2: image2Url,
          },
        }),
      })
        .then(() => {
          setData({ methodName: "", description: "", link: "", public: true });
          setImage(null);
          setImage2(null);
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The Item was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Payment Methods Settings</h3>
        {user.perms[21].add && (
          <div className="addC" style={{ height: openAdd ? 430 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  width: "80%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <div style={{ width: "45%", height: "100%" }}>
                  <div>
                    <TextField
                      label="Method Name"
                      sx={{ width: "100%", mt: 2 }}
                      size="small"
                      value={data.methodName}
                      onChange={(e) => handleBannerDataChange("methodName", e.target.value)}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Link"
                      sx={{ width: "100%", mt: 2 }}
                      size="small"
                      value={data.link}
                      onChange={(e) => handleBannerDataChange("link", e.target.value)}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Description (optional)"
                      sx={{ width: "100%", mt: 2 }}
                      size="small"
                      multiline
                      rows={3}
                      value={data.description}
                      onChange={(e) => handleBannerDataChange("description", e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ width: "45%", height: "100%" }}>
                  <div
                    style={{
                      border: "dashed",
                      borderWidth: 1,
                      borderColor: "grey",
                      height: "46%",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: 5,
                      cursor: "pointer",
                      marginTop: 15,
                    }}
                    onClick={() => hiddenFileInput.current.click()}>
                    {image ? (
                      <img
                        src={URL.createObjectURL(image)}
                        style={{
                          width: 45,
                          aspectRatio: 1,
                          borderRadius: 55,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img src={addImageIcon} style={{ width: 45 }} />
                    )}
                    <p style={{ color: "#888", fontSize: 13 }}>Click here to add main image</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div
                    style={{
                      border: "dashed",
                      borderWidth: 1,
                      borderColor: "grey",
                      height: "46%",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: 5,
                      cursor: "pointer",
                      marginTop: 15,
                    }}
                    onClick={() => hiddenFileInput2.current.click()}>
                    {image2 ? (
                      <img
                        src={URL.createObjectURL(image2)}
                        style={{
                          width: 45,
                          aspectRatio: 1,
                          borderRadius: 55,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img src={addImageIcon} style={{ width: 45 }} />
                    )}
                    <p style={{ color: "#888", fontSize: 13 }}>Click here to add shadow image</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImage2Change}
                      ref={hiddenFileInput2}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadData() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Add a new Payment Method
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>
            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setImage(null);
                  setImage2(null);
                }}
                className="cancelBTN">
                Cancel
              </div>
            )}
          </div>
        )}
        <PaymentMethodsDataTable
          data={items}
          user={user}
          endpoint={"payment-methods"}
          setRefresh={setRefresh}
          refresh={refresh}
          permNumber={21}
        />
      </div>
    </div>
  );
}
